import { axiosObject } from "../config";

function getBankByCode(data: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/banks/_read";
    let payload = {
      apiConfig: {
        includeRelations: ["logo"],
      },
      filterBy: [
        {
          attribute: "short_code",
          op: "eq",
          value: data,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getBankByUuid(uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/banks/_read";
    let payload = {
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function getBankByFilter(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/banks/_read";
    // let payload = {
    //     apiConfig: {
    //       includeRelations: ["logo"],
    //     },
    //     filterBy: [
    //       {
    //         attribute: "short_code",
    //         op: "eq",
    //         value: data,
    //       },
    //     ],
    //   };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export { getBankByCode, getBankByUuid, getBankByFilter };
